import type { FaqItem } from "@/components/seo/FaqSection";

/** FAQ institucional exibido na Home e nas páginas de produto (também vira schema FAQPage). */
export const FAQ_GERAL: FaqItem[] = [
  {
    q: "Como comprar óculos no atacado para revenda?",
    a: "Para comprar óculos no atacado na Atacado Óptico, basta navegar pelo nosso catálogo online, selecionar os modelos desejados de armações, óculos de sol ou acessórios e finalizar o pedido diretamente pelo site. Oferecemos condições especiais e preços competitivos para lojistas e ópticas de todo o Brasil.",
  },
  {
    q: "Qual é o pedido mínimo na Atacado Óptico?",
    a: "O nosso sistema foi planejado para atender desde pequenos empreendedores até grandes redes de ópticas. Verifique as condições atuais de valores e quantidade mínima de peças diretamente no carrinho de compras ou entre em contato com nosso suporte comercial.",
  },
  {
    q: "Os óculos de sol possuem proteção UV400 de fábrica?",
    a: "Sim, todos os óculos de sol distribuídos pela Atacado Óptico contam com proteção real UV400 nas lentes, garantindo total segurança contra os raios solares UVA e UVB, além de estarem em conformidade com as normas técnicas do mercado óptico.",
  },
  {
    q: "Como funciona o envio e o prazo de entrega para a minha região?",
    a: "Realizamos envios para todo o Brasil através de transportadoras parceiras e Correios. O prazo de entrega e o valor do frete variam de acordo com o CEP de destino e a modalidade escolhida no momento do checkout em nosso site.",
  },
  {
    q: "Os produtos acompanham estojo e flanela para revenda?",
    a: "Dispomos de uma linha completa de acessórios que inclui estojos, cases, limpa-lentes e flanelas de microfibra. Verifique a descrição técnica de cada produto para confirmar se os acessórios já estão inclusos no modelo escolhido ou se devem ser adquiridos separadamente no catálogo.",
  },
];
